import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql, navigate } from 'gatsby';
import {
  Header,
  Footer,
  getMainNavData,
  getUtilityNavData,
  getFooterNavData,
  getBreadCrumb,
  EmergencyAlerts,
  Icon,
  DangerousWrapper,
  DecorativeLink,
  isInternalLink,
  ButtonFixedFeedback
} from '@budget-monorepo/shared-ui';

import './index.scss';

const StaticFix = (props) => {
  const staticRender = {
    render: (data) => {
      let component = null;
      if (props) {
        const {
          type, activeIndex, renderBanner, renderFeedbackButton
        } = props;
        const footerProps = {};
        const headerProps = {};
        const onNavigateCallBack = (href) => {
          if (isInternalLink(href)) {
            navigate(href);
          } else {
            // eslint-disable-next-line no-undef
            window.location.assign(href);
          }
        };
        let bannerProps = {};
        let feedbackButtonProps = {};
        let i = 0;
        const navEdgesMaxLength = data.allNavJson.edges.length;
        for (; i < navEdgesMaxLength; i += 1) {
          const edge = data.allNavJson.edges[i];
          const {
            navType, navItems, href, text
          } = edge.node;
          if (type === 'header') {
            if (navType === 'header') {
              headerProps.mainNav = {
                mainNav: getMainNavData(navItems, activeIndex),
                onNavigateCallBack
              };
              headerProps.siteName = edge.node.siteName;
              headerProps.title = edge.node.title;
              headerProps.theme = 'capital';
              headerProps.subTitle = edge.node.subTitle;
            }
            if (navType === 'utility') {
              headerProps.utilityNav = {
                items: getUtilityNavData(navItems)
              };
            }
          }
          if (type === 'footer') {
            if (navType === 'footer') {
              footerProps.footerLinks = {
                items: getFooterNavData(navItems),
                showNavHeading: true
              };
            }
            if (navType === 'social') {
              footerProps.socialLinks = {
                items: navItems
              };
            }
          }
          // eslint-disable-next-line no-undef
          if (type === 'banner' && renderBanner && typeof window !== 'undefined' && (sessionStorage.getItem(edge.node.guid) === 'undefined' || !sessionStorage.getItem(edge.node.guid))) {
            if (navType === 'banner') {
              bannerProps = {
                id: edge.node.guid,
                theme: edge.node.theme || 'c-warning',
                // eslint-disable-next-line no-undef, no-loop-func
                onButtonCloseClick: ({ close }) => sessionStorage.setItem(edge.node.guid, close),
                emergencyHeader: {
                  prefix: navItems[0].prefix,
                  icon: navItems[0].icon ? <Icon name={navItems[0].icon} /> : null,
                  // eslint-disable-next-line react/prop-types
                  title: () => (
                    <span>
                      <DangerousWrapper rawHtml={edge.node.title} htmlTag="span" />
                      {' '}
                      <DecorativeLink href={navItems[0].href} text={navItems[0].text} />
                    </span>
                  )
                }
              };
            }
          }
          if (type === 'feedback' && renderFeedbackButton) {
            if (navType === 'feedback') {
              feedbackButtonProps = {
                href,
                text
              };
            }
          }
        }
        if (headerProps.mainNav && headerProps.utilityNav) {
          component = <Header hideHeaderSearch={props.hideHeaderSearch} {...headerProps} />;
        }
        if (footerProps.footerLinks && footerProps.socialLinks) {
          component = <Footer {...footerProps} />;
        }
        if (bannerProps.id) {
          component = <EmergencyAlerts {...bannerProps} />;
        }
        if (feedbackButtonProps.href) {
          component = <ButtonFixedFeedback {...feedbackButtonProps} />;
        }
      }
      return component;
    }
  };
  return(
    <StaticQuery
      query={graphql`
          query {
            allNavJson {
              edges {
                node {
                  ...SiteNav
                }
              }
            }
          }
        `}
      {...staticRender}
    />
  );
};

// eslint-disable-next-line react/prefer-stateless-function
const Layout = (props) => {
  const {
    pre, breadcrumbprops, pageTitle, dataTimeStamp, buildTimeStamp, activeIndex, hideHeaderSearch, above, containerClasses, children, below
  } = props;
  const renderBanner = parseInt(process.env.RENDER_BANNER, 10) !== 0;
  const renderFeedbackButton = parseInt(process.env.RENDER_FEEDBACK_BUTTON, 10) !== 0;
  return(
    <Fragment>
      <StaticFix type="header" activeIndex={activeIndex} hideHeaderSearch={hideHeaderSearch} />
      <StaticFix type="banner" renderBanner={renderBanner} />
      <main id="main-content">
        {pre && pre()}
        {getBreadCrumb(breadcrumbprops, pageTitle, dataTimeStamp, buildTimeStamp)}
        {above && above()}
        <div className={`ma__container ${containerClasses}`}>
          {
            // eslint-disable-next-line react/prop-types
          (typeof children === 'function') ? children() : children
          }
        </div>
        {below && below()}
      </main>
      <StaticFix type="footer" />
      <StaticFix type="feedback" renderFeedbackButton={renderFeedbackButton} />
    </Fragment>
  );
};


Layout.propTypes = {
  pre: PropTypes.func,
  above: PropTypes.func,
  below: PropTypes.func,
  containerClasses: PropTypes.string,
  activeIndex: PropTypes.number,
  pageTitle: PropTypes.string,
  breadcrumbprops: PropTypes.array,
  hideHeaderSearch: PropTypes.bool,
  dataTimeStamp: PropTypes.string,
  buildTimeStamp: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

Layout.defaultProps = {
  containerClasses: '',
  breadcrumbprops: [],
  pageTitle: '',
  hideHeaderSearch: false
};

StaticFix.propTypes = {
  type: PropTypes.string,
  activeIndex: PropTypes.number,
  hideHeaderSearch: PropTypes.bool,
  renderBanner: PropTypes.bool,
  renderFeedbackButton: PropTypes.bool
};

export default Layout;
